/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAuthenticationConfigurationResponse } from '../../models/get-authentication-configuration-response';

export interface GetByOrganizationId$Params {
  organizationId: string;
}

export function getByOrganizationId(http: HttpClient, rootUrl: string, params: GetByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAuthenticationConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getByOrganizationId.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAuthenticationConfigurationResponse>;
    })
  );
}

getByOrganizationId.PATH = '/v1/organizations/{organizationId}/configuration/authentication';
